import styled from "styled-components";

// "overflow: hidden" is the substitute of the scrolling prop of the iframe.
// currently doens't work, but just to be prepared in case in the future it changes and they
// truly depecrated the scrolling prop.
export const VideoReplayDesk = styled.iframe`
  aspect-ratio: 16 / 9;
  width: 100%;
  display: flex;
  overflow: hidden !important;
  background-color: black;
`;
